import Api from '@/services/Api'

export default {
    getVigencias() {
        return Api().get('impuestos/liquidacion/vigencias')
    },
    getFormularios() {
        return Api().get('impuestos/liquidacion/formularios')
    },
    getMunicipios(nit) {
        return Api().get('impuestos/liquidacion/municipios', { params: { nit } })
    },
    getLiquidacion(datos) {
        return Api().get('impuestos/liquidacion/resumen', { params: datos })
    }
}